import React from 'react';

import { Path } from '~/paths';
import { ChapterWrapper } from '~/ChapterWrapper';
import Footer from '~/Footer';
import { ELink } from '~/ExternalLink';


export const LinearRegressionMeta = {
    title: "Lineární regrese",
    shortTitle: "Lineární regrese",
    path: Path.linear_regression,
    element: (sectionNumber:string) => <LinearRegression sectionNumber={sectionNumber}/>,
    sectionNumber: "",
}

const TOCSpec = [
    "summary",
];


export function LinearRegression({sectionNumber}: {sectionNumber: string}) {

    return (
        <ChapterWrapper sectionNumber={sectionNumber} title={LinearRegressionMeta.title} TOCSpec={TOCSpec}>

            <p><i>Super-stručná verze.</i></p>

            Viz přednášky (poznámky, videa), nebo např.

            &nbsp;<ELink href={"https://www.youtube.com/watch?v=eYTumjgE2IY"}>youtube</ELink>,

            &nbsp;nebo

            &nbsp;<ELink href={"https://is.muni.cz/do/rect/el/estud/prif/ps13/prav_stat/web_2/pages/06-regresni-analyza.html"}>kurz MUNI</ELink>

            &nbsp;(matematičtější).

            <p>
            Na přednášce jsme toto do detailu neprobírali; jediné, co se stihlo, bylo následující shrnutí:
            </p>

            <p>
            Z popisné statistiky víme, že regresní přímka má rovnici {"$y = ax + b$"}, kde:
            {`$$\\begin{align*}
                a & = \\frac{\\frac{1}{n} \\sum x_i y_i -  \\bar{x} \\bar{y}}{ \\sigma_x^2} \\\\
                b & = \\bar{y} - a \\bar{x}.
            \\end{align*}$$`}
            </p>
            <p>Když si řekneme že hodnoty {"$x_i$"} jsou fixní (nezávislá deterministická proměnná), a
            hodnoty {"$y_i$"} jsou hodnoty náhodných veličin  {"$Y_i$"} (např. měření zatížené normálním šumem),
            pak koeficienty {"$a$"} a {"$b$"} jsou také náhodné veličiny:
            {`$$\\begin{align*}
                A & = \\frac{\\frac{1}{n} \\sum x_i Y_i -  \\bar{x} \\bar{Y}}{ \\sigma_x^2}\\\\
                B & = \\bar{Y} - A \\bar{x}.
            \\end{align*}$$`}
            </p>
            <p>Můžeme si představit, že {"$Y_i = ax_i + b + \\epsilon_i$"},
            kde {"$\\epsilon_i \\sim N(0, \\sigma^2)$"} jsou nezávislé náhodné veličiny (reprezentující šum měření);
            potom {"$Y_i \\sim N(ax_i + b, \\sigma^2)$"} jsou nezávislé normální náhodné veličiny.
            </p>
            <p>
            Je vidět, že {"$A$"} a {"$B$"} jsou získané jako lineární kombinace náhodných veličin {"$Y_i$"},
            takže {"$A$"} a {"$B$"} mají také normální rozdělení, a lze dopočítat jejich střední hodnotu a rozptyl
            na základě, parametrů {"$a$"}, {"$b$"} a {"$\\sigma^2$"}.
            </p>

            <p>
            Tímpádem si dokážeme představit, že pro {"$a$"} a {"$b$"} lze pomocí {"$A$"} a {"$B$"} sestavit
            intervaly spolehlivosti.
            </p>

            <p>Pro zafixované {"$x^*$"} je náhodná veličina {"$Y^* = Ax^* + B$"} odhadem
            "hodnoty regresní přímky v bodě {"$x^*$"}"; rozptyl této náhodné veličiny je
            tím větší, čím je {"$x^*$"} dále od průměru {"$\\bar{x}$"}. To dává vzniknout konfidenčnímu pásu
            kolem regresní přímky ve tvaru "carvingové lyže" (nejužší uprostřed, rozšiřující se směrem od středu).
            </p>
            <Footer/>
        </ChapterWrapper>
    );
}

